/** @format */

import { HomrScheduleContent } from './homr/homr-schedule-content.interface';
import { ProductSku } from './product-sku.interface';

export interface MessageRequest {
  atsAvailability?: any;
  boplAvailability?: any;
  boplExperienceEnabled?: boolean;
  buyable: boolean;
  homrSchedule?: HomrScheduleContent;
  isBopisKillSwitch?: boolean;
  isBopisPickup?: boolean;
  isInventoryLimited?: boolean;
  isSelectedInventoryGreaterThanAvailable?: boolean;
  isSkuResolved: boolean;
  isaAvailability?: any;
  multiSku?: { bopisable: boolean; buyable: boolean; isable: boolean };
  nearbyStores?: boolean;
  qty?: number | string;
  sku: ProductSku;
  storeSelected: boolean;
  storeStatus?: any;
}
